import { HttpInterceptorFn } from '@angular/common/http';

export const headersInterceptor: HttpInterceptorFn = (request, next) => {
  const contentTypeHeader = request.detectContentTypeHeader();
  if (contentTypeHeader) return next(request.clone({ headers: request.headers.set('Content-Type', contentTypeHeader) }));
  return next(request);
};
